import { render, staticRenderFns } from "./AppNoData.vue?vue&type=template&id=21776f18&scoped=true"
import script from "./AppNoData.vue?vue&type=script&lang=js"
export * from "./AppNoData.vue?vue&type=script&lang=js"
import style0 from "./AppNoData.vue?vue&type=style&index=0&id=21776f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21776f18",
  null
  
)

export default component.exports